import React, {useEffect, useRef, useState} from 'react';
import {format} from 'date-fns';
import moment from 'moment';

import '../../react-calendar/src/styles.scss'; // main style file
import '../../react-calendar/src/theme/default.scss'; // theme css file


const EditableItemDate = ({type, id, value, apiLink}) => {
    const [date, setDate] = useState(moment(value).toDate());
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const handleChange = (date) => {
        setDate(date);
    };

    const handleSubmit = () => {
        setEditing(false);

        fetch(apiLink, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                itemId: id,
                type: type,
                value: moment(date).format('YYYY-MM-DD'),
            }),
        }).then(r => r.json())
            .then(data => {
                window.location.reload();
            });
    }

    useEffect(() => {
        if (editing && inputRef.current) {
            inputRef.current.focus();

            if (inputRef.current.showPicker) {
                console.log(inputRef.current.showPicker);
                inputRef.current.showPicker();
            }
        }
    }, [editing]);

    if (editing) {
        return <span>
        <input type='date'
               className={'form-control'}
               value={format(date, 'yyyy-MM-dd')}

               ref={inputRef}
               onChange={(e) => handleChange(moment(e.target.value).toDate())}
               onBlur={() => handleSubmit()}
        />
        </span>;
    }
    else {
        return <span onClick={() => setEditing(true)} className={'d-flex align-items-center'} style={{cursor: 'pointer'}}>
                <span>{date.toLocaleDateString()}</span>
                <i className={'fas small text-black-50 fa-pencil-alt ms-2'}/>
            </span>;
    }

}
export default EditableItemDate;
